import * as swcHelpers from '@swc/helpers';
import { actions } from '@grandvisionhq/state';
import { startPrescriptionGlassesConfiguration } from '../actions.js';

const initialState = {};
const reducer = actions.reducer(initialState, /**
   * Set the correct frameSku and always reset the configurator to the initial state
   */ actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frameSku , isExtraValidationStepEnabled , usps , rxEntryTypes , bookAppointmentRoute ,  } ,  })=>{
    return swcHelpers.objectSpread({}, initialState, {
        frameSku,
        isExtraValidationStepEnabled,
        usps,
        rxEntryTypes,
        bookAppointmentRoute
    });
}));

export { initialState, reducer };
//# sourceMappingURL=reducer.js.map
